import { css } from "lit";

export const style = css`
	div.qp-node {
		background-color: #FFFFCC;
		margin: 2px;
		padding: 2px;
		border: 1px solid black;
	}

	div.qp-node,
	div.qp-tt {
		font-size: 11px;
		line-height: normal;
	}

	.qp-statement-header {
		border-color: black;
		border-style: solid;
		border-width: 1px 0px 1px 0px;
		padding: 0.3em;
	}

	.qp-statement-header-row {
		width: 100%;
		height: 15.6px;
	}

	.qp-statement-header-row > div {
		width: 100%;
		position: absolute;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.missing-index {
		color: green;
	}

	.qp-statement-header,
	.qp-node>div {
		font-family: Monospace;
	}

	.qp-node>div {
		text-align: center;
	}

	div[class|='qp-icon'] {
		height: 32px;
		width: 32px;
		margin-left: auto;
		margin-right: auto;
		background-repeat: no-repeat;
		position: relative;
	}

	.qp-tt {
		top: 4em;
		left: 2em;
		border: 1px solid black;
		background-color: #FFFFEE;
		padding: 2px;
		width: 30em;
	}

	.qp-tt div,
	.qp-tt table {
		font-family: Sans-Serif;
		text-align: left;
	}

	.qp-tt table {
		border-width: 0px;
		border-spacing: 0px;
		margin-top: 10px;
		margin-bottom: 10px;
		width: 100%;
	}

	.qp-tt td,
	.qp-tt th {
		font-size: 11px;
		border-bottom: solid 1px Black;
		padding: 1px;
	}

	.qp-tt td {
		text-align: right;
		padding-left: 10px;
	}

	.qp-tt th {
		text-align: left;
	}

	.qp-bold,
	.qp-tt-header {
		font-weight: bold;
	}

	.qp-tt-header {
		text-align: center;
	}

	/* Icons */
	.qp-icon-Catchall{background: url('/assets/qp-icons.png') -96px -256px }
	.qp-icon-ArithmeticExpression{background: url('/assets/qp-icons.png') -0px -0px }
	.qp-icon-Assert{background: url('/assets/qp-icons.png') -32px -0px }
	.qp-icon-Assign{background: url('/assets/qp-icons.png') -64px -0px }
	.qp-icon-Bitmap{background: url('/assets/qp-icons.png') -256px -192px }
	.qp-icon-BookmarkLookup{background: url('/assets/qp-icons.png') -128px -0px }
	.qp-icon-ClusteredIndexDelete{background: url('/assets/qp-icons.png') -160px -0px }
	.qp-icon-ClusteredIndexInsert{background: url('/assets/qp-icons.png') -192px -0px }
	.qp-icon-ClusteredIndexScan{background: url('/assets/qp-icons.png') -224px -0px }
	.qp-icon-ClusteredIndexSeek{background: url('/assets/qp-icons.png') -256px -0px }
	.qp-icon-ClusteredIndexMerge{background: url('/assets/qp-icons.png') -0px -256px }
	.qp-icon-KeyLookup{background: url('/assets/qp-icons.png') -256px -0px }
	.qp-icon-ClusteredIndexUpdate{background: url('/assets/qp-icons.png') -288px -0px }
	.qp-icon-Collapse{background: url('/assets/qp-icons.png') -0px -32px }
	.qp-icon-ComputeScalar{background: url('/assets/qp-icons.png') -32px -32px }
	.qp-icon-Concatenation{background: url('/assets/qp-icons.png') -64px -32px }
	.qp-icon-ConstantScan{background: url('/assets/qp-icons.png') -96px -32px }
	.qp-icon-Convert{background: url('/assets/qp-icons.png') -128px -32px }
	.qp-icon-CursorCatchall{background: url('/assets/qp-icons.png') -96px -0px }
	.qp-icon-Declare{background: url('/assets/qp-icons.png') -160px -32px }
	.qp-icon-Delete{background: url('/assets/qp-icons.png') -288px -160px }
	.qp-icon-DistributeStreams{background: url('/assets/qp-icons.png') -224px -32px }
	.qp-icon-Dynamic{background: url('/assets/qp-icons.png') -256px -32px }
	.qp-icon-EagerSpool{background: url('/assets/qp-icons.png') -192px -160px }
	.qp-icon-FetchQuery{background: url('/assets/qp-icons.png') -288px -32px }
	.qp-icon-Filter{background: url('/assets/qp-icons.png') -0px -64px }
	.qp-icon-GatherStreams{background: url('/assets/qp-icons.png') -32px -64px }
	.qp-icon-HashMatch{background: url('/assets/qp-icons.png') -64px -64px }
	.qp-icon-HashMatchRoot{background: url('/assets/qp-icons.png') -64px -64px }
	.qp-icon-HashMatchTeam{background: url('/assets/qp-icons.png') -64px -64px }
	.qp-icon-If{background: url('/assets/qp-icons.png') -96px -64px }
	.qp-icon-Insert{background: url('/assets/qp-icons.png') -0px -192px }
	.qp-icon-InsertedScan{background: url('/assets/qp-icons.png') -128px -64px }
	.qp-icon-Intrinsic{background: url('/assets/qp-icons.png') -160px -64px }
	.qp-icon-IteratorCatchall{background: url('/assets/qp-icons.png') -96px -0px }
	.qp-icon-Keyset{background: url('/assets/qp-icons.png') -192px -64px }
	.qp-icon-LanguageElementCatchall{background: url('/assets/qp-icons.png') -96px -0px }
	.qp-icon-LazySpool{background: url('/assets/qp-icons.png') -192px -160px }
	.qp-icon-LogRowScan{background: url('/assets/qp-icons.png') -224px -64px }
	.qp-icon-MergeInterval{background: url('/assets/qp-icons.png') -256px -64px }
	.qp-icon-MergeJoin{background: url('/assets/qp-icons.png') -288px -64px }
	.qp-icon-NestedLoops{background: url('/assets/qp-icons.png') -0px -96px }
	.qp-icon-NonclusteredIndexDelete{background: url('/assets/qp-icons.png') -32px -96px }
	.qp-icon-NonclusteredIndexInsert{background: url('/assets/qp-icons.png') -64px -96px }
	.qp-icon-IndexScan{background: url('/assets/qp-icons.png') -96px -96px }
	.qp-icon-IndexSeek{background: url('/assets/qp-icons.png') -128px -96px }
	.qp-icon-NonclusteredIndexSpool{background: url('/assets/qp-icons.png') -160px -96px }
	.qp-icon-NonclusteredIndexUpdate{background: url('/assets/qp-icons.png') -192px -96px }
	.qp-icon-OnlineIndexInsert{background: url('/assets/qp-icons.png') -224px -96px }
	.qp-icon-ParameterTableScan{background: url('/assets/qp-icons.png') -256px -96px }
	.qp-icon-PopulateQuery{background: url('/assets/qp-icons.png') -192px -224px }
	.qp-icon-RdiLookup{background: url('/assets/qp-icons.png') -0px -128px }
	.qp-icon-RefreshQuery{background: url('/assets/qp-icons.png') -32px -128px }
	.qp-icon-RemoteDelete{background: url('/assets/qp-icons.png') -64px -128px }
	.qp-icon-RemoteInsert{background: url('/assets/qp-icons.png') -96px -128px }
	.qp-icon-RemoteQuery{background: url('/assets/qp-icons.png') -128px -128px }
	.qp-icon-RemoteScan{background: url('/assets/qp-icons.png') -160px -128px }
	.qp-icon-RemoteUpdate{background: url('/assets/qp-icons.png') -192px -128px }
	.qp-icon-RepartitionStreams{background: url('/assets/qp-icons.png') -224px -128px }
	.qp-icon-Result{background: url('/assets/qp-icons.png') -256px -128px }
	.qp-icon-RowCountSpool{background: url('/assets/qp-icons.png') -288px -128px }
	.qp-icon-Segment{background: url('/assets/qp-icons.png') -0px -160px }
	.qp-icon-Sequence{background: url('/assets/qp-icons.png') -32px -160px }
	.qp-icon-SequenceProject{background: url('/assets/qp-icons.png') -224px -224px }
	.qp-icon-SnapShot{background: url('/assets/qp-icons.png') -256px -224px }
	.qp-icon-Sort{background: url('/assets/qp-icons.png') -128px -160px }
	.qp-icon-Split{background: url('/assets/qp-icons.png') -160px -160px }
	.qp-icon-Spool{background: url('/assets/qp-icons.png') -192px -160px }
	.qp-icon-Statement{background: url('/assets/qp-icons.png') -256px -128px }
	.qp-icon-StreamAggregate{background: url('/assets/qp-icons.png') -224px -160px }
	.qp-icon-Switch{background: url('/assets/qp-icons.png') -256px -160px }
	.qp-icon-TableDelete{background: url('/assets/qp-icons.png') -288px -160px }
	.qp-icon-TableInsert{background: url('/assets/qp-icons.png') -0px -192px }
	.qp-icon-TableScan{background: url('/assets/qp-icons.png') -32px -192px }
	.qp-icon-TableSpool{background: url('/assets/qp-icons.png') -64px -192px }
	.qp-icon-WindowSpool{background: url('/assets/qp-icons.png') -64px -192px }
	.qp-icon-TableUpdate{background: url('/assets/qp-icons.png') -96px -192px }
	.qp-icon-TableValuedFunction{background: url('/assets/qp-icons.png') -128px -192px }
	.qp-icon-Top{background: url('/assets/qp-icons.png') -160px -192px }
	.qp-icon-UDX{background: url('/assets/qp-icons.png') -192px -192px }
	.qp-icon-Update{background: url('/assets/qp-icons.png') -96px -192px }
	.qp-icon-While{background: url('/assets/qp-icons.png') -224px -192px }
	.qp-icon-StmtCursor{background: url('/assets/qp-icons.png') -96px -256px }
	.qp-icon-StmtCond{background: url('/assets/qp-icons.png') -0px -224px }
	.qp-icon-FastForward{background: url('/assets/qp-icons.png') -96px -0px }
	.qp-icon-WindowAggregate{background: url('/assets/qp-icons.png') -160px -256px }
	.qp-icon-AdaptiveJoin{background: url('/assets/qp-icons.png') -288px -224px }
	.qp-icon-IndexSpool{background: url('/assets/qp-icons.png') -160px -96px }
	.qp-icon-IndexInsert{background: url('/assets/qp-icons.png') -64px -96px }
	.qp-icon-IndexDelete{background: url('/assets/qp-icons.png') -32px -96px }
	.qp-icon-IndexUpdate{background: url('/assets/qp-icons.png') -192px -96px }
	.qp-icon-ColumnStoreIndexScan{background: url('/assets/qp-icons.png') -128px -224px }
	.qp-icon-ColumnStoreIndexInsert{background: url('/assets/qp-icons.png') -64px -224px }
	.qp-icon-ColumnStoreIndexDelete{background: url('/assets/qp-icons.png') -32px -224px }
	.qp-icon-ColumnStoreIndexUpdate{background: url('/assets/qp-icons.png') -160px -224px }
	.qp-icon-ColumnStoreIndexMerge{background: url('/assets/qp-icons.png') -96px -224px }
	.qp-icon-DeletedScan{background: url('/assets/qp-icons.png') -32px -256px }
	.qp-icon-TableMerge{background: url('/assets/qp-icons.png') -65px -256px }
	.qp-icon-BatchHashTableBuild{background: url('/assets/qp-icons.png') -128px -256px }

	.qp-iconwarn {
		background: url('/assets/qp-icons.png') -304px -208px;
		height: 16px;
		width: 16px;
		position: absolute;
		top: 16px;
	}

	.qp-iconpar {
		background: url('/assets/qp-icons.png') -304px -192px;
		height: 16px;
		width: 16px;
		position: absolute;
		top: 16px;
		left: 16px;
	}

	.qp-iconbatch {
		background: url('/assets/qp-icons.png') -288px -192px;
		height: 16px;
		width: 16px;
		position: absolute;
		top: 16px;
	}

	/* Layout - can't touch this */
	.qp-tt {
		position: absolute;
		z-index: 1;
		white-space: normal;
		-webkit-transition-delay: 0.5s;
		transition-delay: 0.5s;
	}

	div.qp-node .qp-tt,
	.qp-noCssTooltip div.qp-node:hover .qp-tt {
		visibility:  collapse;
	}

	div.qp-node:hover .qp-tt {
		visibility: visible;
	}

	.qp-tt table {
		white-space: nowrap;
	}

	.qp-node {
		position: relative;
		white-space: nowrap;
		display: inline-block;
		vertical-align: middle;
	}

	.qp-node-outer {
		height: 76.4px;
		display: table-cell;
	}

	.qp-tr {
		display: table;
	}

	.qp-tr>div {
		display: table-cell;
		padding-left: 20px;
	}

	.qp-root {
		position: relative;
		display: block;
		width: max-content;
		min-width: 100%;
	}

	.qp-root svg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		overflow: visible;
	}

	.qp-root polyline {
		pointer-events: auto;
	}

	.qp-pane {
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* "Query N: Query cost (relative to the batch): X%" - green (cheap) to red (the most expensive) */
	.qp-pane-header {
		flex: none;
		padding: 0.3em 0.5em;
		color: #fff;
		font-family: Monospace;
		font-size: 11px;
		line-height: normal;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.qp-pane-body {
		flex: 1 1 auto;
		min-height: 0;
		overflow: auto;
	}

	/* native scrollbars styled to match og-slider */
	.qp-pane-body::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	.qp-pane-body::-webkit-scrollbar-track {
		background: var(--og-slider-background-color);
	}

	.qp-pane-body::-webkit-scrollbar-thumb {
		background: var(--og-slider-bar-color);
		border-radius: 6px;
	}

	.qp-pane-body::-webkit-scrollbar-corner {
		background: var(--og-slider-background-color);
	}

`;